import { SHLadderSelection } from './s-h-ladder-selection';
import { SurvivalHorizonData } from '@liquitics/transaction';
export class SHLadderConfig {
    liveStreaming: boolean;
    blockRetriever: () => string[];
    blockKeyExtractor: (survivalHorizonData: SurvivalHorizonData) => string;
    chartBlockRetriever: () => string[];
    rowSelectionHandler: (selection: SHLadderSelection) => void;
}
